<div
  *ngIf="sessionId !== 'empty'"
  class="ui vertical basic segment wrap"
  style="width: 100%"
  style="position: relative"
  [ngClass]="{ scrollMe: fullScreenMode }"
>
  <div
    class="ui segment conversation-header"
    *ngIf="!fullScreenMode"
    appPadding="24px"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <div
      class="service-details-section"
      fxFlex="50"
      fxLayout="row"
      fxLayoutGap="20px"
      fxLayoutAlign="center center"
    >
      <div class="icon-section" fxFlex="14">
        <span class="ui huge grey circular label">{{
          getAcronym(conversationData?.subtopic.topic.topic)
        }}</span>
      </div>
      <div
        class="conversation-details-section"
        fxFlex="75"
        fxLayout="column"
        fxLayoutGap="8px"
      >
        <h3 class="ui header">{{ conversationData?.subtopic.topic.topic }}</h3>
        <p class="service-description">
          {{ conversationData?.subtopic.subtopic }}
        </p>
      </div>
    </div>
    <div
      class="activity-time-section"
      fxFlex="50"
      style="
        display: flex;
        align-items: center;
        gap: 16px;
        justify-content: flex-end;
      "
    >
      <p class="status-time">
        <span
          >Last Activity:
          {{ conversationData?.lastActivity | date: "h:mm a, EEEE d MMMM y" }}
        </span>
      </p>
      <div>
        <div (click)="goToFullScreen()" class="open_close">
          <img src="assets/icons/arrows-pointing-out.svg" alt="data" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="success || error" appMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <div style="position: absolute; top: 0; z-index: 100; top: 10px; right: 20px">
    <div
      (click)="goToFullScreen()"
      class="open_close"
      *ngIf="fullScreenMode === true"
    >
      <img src="assets/icons/arrows-pointing-in.svg " alt="data" />
    </div>
  </div>

  <div
    #scrollContainer
    id="scrollMe"
    infinite-scroll
    [scrollWindow]="true"
    [infiniteScrollUpDistance]="2"
    (scrolled)="onScrollDown($event)"
    (scrolledUp)="onScrollUp($event)"
    class="ui secondary segment messages-container"
  >
    <!-- current chat messages -->
    <div class="hide-scroll">
      <!-- messages with timer displayed when during api request-->

      <div
        class="scroll-wrapper ui basic segment"
        style="width: 100%"
        [ngClass]="{ loading: pending }"
      >
        <div
          class="scroll-wrapper ui basic segment"
          style="padding-bottom: 150px; width: 100%"
        >
          <div
            class="ui vertical basic segment wrap-empty2"
            appPadding="0"
            *ngIf="messages.length < 1"
          >
            <div
              class="ui vertical basic segment empty-data-view"
              appPadding="0"
              style="border: none"
            >
              <!-- chat messages -->
              <div
                class="content"
                fxLayout="column"
                fxLayoutAlign="center center"
              >
                <img src="assets/images/empty-data.svg" alt="" />
                <div class="text">
                  <h3 class="heading">
                    Your Conversation Screen is empty.
                    <br />
                    Start chatting to see conversation screen
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let group of messages">
            <div
              class="comment-container"
              fxLayout="column"
              fxLayoutGap="44px"
              fxLayoutAlign="start center"
              style="margin: 30px 0px"
            >
              <span class="comment-date">{{
                group.date | date: "dd MMM yyyy"
              }}</span>
            </div>
            <div
              *ngFor="let comment of group.messages"
              style="margin-bottom: 20px"
            >
              <app-chat-messages
                [typing]="replyForm.valid"
                [msg]="comment"
                (reply)="onReply($event)"
              ></app-chat-messages>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Forms to send a chat that is or is not a reply -->
  </div>
  <div class="container_reply">
    <div
      appPadding="0px"
      appMargin
      marginX="30px"
      marginT="10px"
      class="ui basic segment"
      *ngIf="isReply"
    >
      <div appPadding="0px" class="ui basic segment" id="reply-block">
        <div
          class="ui circular red tiny right floating label clickable"
          (click)="removeReply()"
        >
          <i appMargin="0px" class="cancel icon"></i>
        </div>
        <div appMargin="0px" class="ui segment">
          <app-chat-messages isReply="true" [msg]="isReply">
          </app-chat-messages>
        </div>
      </div>
      <div class="ui form" [formGroup]="replyForm">
        <div
          class="field"
          fxLayout="row"
          fxLayoutGap="3px"
          fxLayoutAlign="space-between end"
        >
          <div class="field" fxFlex="grow">
            <textarea
              class="content-area"
              formControlName="comment"
              placeholder="Write a message"
            >
          Write a message</textarea
            >
          </div>
        </div>
        <!-- attachment shown if added -->
        <div>
          <div
            class="ui image fluid primary label"
            *ngIf="fileObj"
            appMargin
            marginB="10px"
          >
            Attachment:
            <span>{{ fileName }}</span>
            <i
              class="delete icon"
              (click)="removeFile()"
              style="float: right"
              suiPopup
              popupPlacement="top"
              popupText="remove attachment"
            ></i>
          </div>
          <!-- <div appMargin marginY="10px" *ngIf="">
              <sui-message class="info" [isDismissable]="false">
                <p>You may attach only one file at a time!</p>
                <p>please remove previous attachment first to make a new selection</p>
              </sui-message>
            </div> -->
        </div>

        <div
          *isPermitted="{ id: 'CHAT', action: 'add' }"
          class="field"
          fxLayout="row"
          fxLayoutGap="3px"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="10%">
            <button class="ui tiny icon button" (click)="uploader.click()">
              <i class="file large outline icon"></i>
            </button>

            <input
              hidden
              type="file"
              accept=".jpg, .jpeg, .png, .pdf,.xlsx,.docx"
              #uploader
              (change)="uploadDoc($event.target.files)"
              placeholder="Browse for documents"
              onclick="value = null"
            />
          </div>

          <div fxFlex class="text-right">
            <button
              class="ui tiny primary button"
              [disabled]="!replyForm.valid || pending"
              (click)="send(isReply.messageId)"
            >
              Send
            </button>
            <!-- <button class="ui tiny icon button">
							<i class="ellipsis vertical icon"></i>
						</button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- not a reply form -->
    <div
      *ngIf="!isReply"
      appMargin
      marginT="5"
      class="ui form"
      [formGroup]="replyForm"
    >
      <div
        class="field"
        fxLayout="row"
        fxLayoutGap="3px"
        fxLayoutAlign="space-between end"
      >
        <div class="field" fxFlex="grow">
          <textarea
            class="content-area"
            formControlName="comment"
            placeholder="Write a message"
          >
        Write a message
        </textarea
          >
        </div>
      </div>

      <!-- attachment shown if added -->
      <div
        *ngIf="fileObj"
        class="ui image fluid primary label"
        appMargin
        marginB="10px"
      >
        Attachment:
        <span>{{ fileName }}</span>
        <i
          class="delete icon"
          (click)="removeFile()"
          style="float: right"
          suiPopup
          popupPlacement="top"
          popupText="remove attachment"
        ></i>
      </div>

      <!-- <div appMargin marginY="10px" *ngIf="checkAttach()">
				<sui-message class="info" [isDismissable]="false">
          <p>You may attach only one file at a time!</p>
          <p>please remove previous attachment first to make a new selection</p>
        </sui-message>
      </div> -->

      <div
        *isPermitted="{ id: 'CHAT', action: 'add' }"
        class="field"
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="space-between center"
      >
        <div fxFlex="10%">
          <button class="ui tiny icon button" (click)="uploader.click()">
            <i class="file large outline icon"></i>
          </button>

          <input
            hidden
            type="file"
            accept=".jpg, .jpeg, .png, .pdf,.xlsx,.docx"
            #uploader
            (change)="uploadDoc($event.target.files)"
            placeholder="Browse for documents"
            onclick="value = null"
          />
        </div>

        <div fxFlex class="text-right">
          <button
            class="ui tiny primary button"
            [disabled]="!replyForm.valid || pending"
            (click)="send('null')"
          >
            Send
          </button>
          <!-- <button class="ui tiny icon button">
											<i class="ellipsis  vertical icon"></i>
											</button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="ui vertical basic segment wrap-empty"
  appPadding="0"
  *ngIf="sessionId === 'empty'"
>
  <div
    class="ui vertical basic segment empty-data-view"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <!-- chat messages -->
    <div class="content" fxLayout="column" fxLayoutAlign="center center">
      <img src="assets/images/empty-data.svg" alt="" />
      <div class="text">
        <h3 class="heading">
          Your Conversation Screen is empty.
          <br />
          Start chatting to see conversation screen
        </h3>
      </div>
    </div>
  </div>
</div>
